import { createContext, useContext, useEffect, useState, type ReactNode } from 'react';
import {
  applyTheme,
  CUSTOMER_THEME_CHANGED_EVENT,
  getStoredTheme,
  type Theme,
} from '../lib/theme';

interface ThemeContextType {
  theme: Theme;
  setTheme: (theme: Theme) => void;
}

const ThemeContext = createContext<ThemeContextType>({ theme: 'sky', setTheme: () => {} });

export function ThemeProvider({ children }: { children: ReactNode }) {
  const [theme, setThemeState] = useState<Theme>(() => getStoredTheme());

  const setTheme = (t: Theme) => {
    applyTheme(t);
  };

  useEffect(() => {
    applyTheme(theme, { emit: false });
  }, [theme]);

  useEffect(() => {
    const syncTheme = () => {
      setThemeState(getStoredTheme());
    };

    window.addEventListener(CUSTOMER_THEME_CHANGED_EVENT, syncTheme);
    return () => window.removeEventListener(CUSTOMER_THEME_CHANGED_EVENT, syncTheme);
  }, []);

  return (
    <ThemeContext.Provider value={{ theme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

// eslint-disable-next-line react-refresh/only-export-components
export const useTheme = () => useContext(ThemeContext);
